import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHeader from '@projectK/components/TableHeader';
import { Fonts } from '@projectK/constants/AppEnums';

const TableHeading = () => {
  return (
    <TableHeader
      sx={{
        position: 'relative',
        '& .tableCell': {
          fontSize: 13,
          padding: 2,
          paddingTop: 0,
          fontWeight: Fonts.BOLD,
          whiteSpace: 'nowrap',
          '&:first-of-type': {
            paddingLeft: 5,
          },
          '&:last-of-type': {
            paddingRight: 5,
          },
        },
      }}
    >
      <TableCell align='left' className='tableCell'>
        Merged By
      </TableCell>
      <TableCell align='center' className='tableCell'>
        Merging Account
      </TableCell>
      <TableCell align='center' className='tableCell'>
        Primary Account
      </TableCell>
      <TableCell align='center' className='tableCell'>
        Merged On
      </TableCell>
    </TableHeader>
  );
};

export default TableHeading;
